import {
  View,
  Text,
  ScrollView,
  Dimensions,
  StyleSheet,
  TouchableOpacity,
  RefreshControl,
} from "react-native";
import React, { useState, useEffect } from "react";
//import MyImageBackground from "../../components/custom/MyImageBackground";
//import Header from "../../components/Header";
import { shadowSm } from "../../colors";
import { AntDesign } from "@expo/vector-icons";
import MyText from "../../components/custom/MyText";
import { primary, gray } from "../../colors";

// import FaqIcon from "../../assets/icons/FaqIcon";
import MyFaq from "../../components/home/MyFaq";
import FAQ from "../../api/get/FAQ";
import { useDispatch, useSelector } from "react-redux";
import translate from "../../functions/translate";
import aboutUs from "../../api/get/aboutUs";
import RenderHtml from "react-native-render-html";
import {
  changeHeaderColor,
  hideBottomNavigation,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";
import { useIsFocused, useNavigation } from "@react-navigation/native";
//import getFaq from "../../api/get/getFaq";
//import { setOffline } from "../redux/main/mainAction";

export default function AboutUs(props) {
  const navigation = useNavigation();
  const [data, setData] = useState({ fa: "", en: "" });
  const main = useSelector((store) => store.main);
  const dispatch = useDispatch();
  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#fcfcfc"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
  }, [isFocused]);
  useEffect(() => {
    aboutUs().then(({ data }) => {
      if (data.status === 200) setData(data.data);
    });
  }, []);
  return (
    <View style={{ flex: 1 }}>
      <ScrollView
        refreshControl={<RefreshControl refreshing={false} />}
        showsVerticalScrollIndicator={false}
        style={{
          marginTop: -20,
          marginBottom: 20,
          flex: 1,
        }}
      >
        <View
          style={{
            width: Dimensions.get("window").width,
            paddingTop: 45,
            alignItems: "center",
            flex: 1,
          }}
        >
          <View style={styles.container}>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                alignItems: "center",
              }}
            >
              {/* <TouchableOpacity
                onPress={() => navigation.goBack()}
                style={{ alignItems: "flex-start" }}
              >
                <AntDesign name="arrowright" size={24} color={gray} />
              </TouchableOpacity> */}

              <View
                style={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <View style={{ marginHorizontal: 10 }}>
                  {/* <FaqIcon source={logo} width={40} height={40} /> */}
                </View>
                <MyText style={{ fontSize: 16, color: primary }}>
                  {translate("about us")}
                </MyText>
              </View>

              <View style={{ flex: 1 }}></View>
            </View>
            <View
              style={{
                width: "100%",
                alignItems: "center",

                marginTop: 10,
              }}
            >
              <View style={{}}>
                <RenderHtml
                  contentWidth={300}
                  source={{ html: main.rtl ? data.fa : data.en }}
                  style={{}}
                />
              </View>
            </View>
          </View>

          <View></View>
          <View style={{ height: 100 }}></View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: "90%",
    ...shadowSm,
    padding: 15,
    alignItems: "center",
  },
  profileImagePlace: {
    width: 100,
    height: 100,
    borderRadius: 50,
    borderWidth: 1,
    borderColor: primary,
    overflow: "hidden",
  },
});
